export const readCookies = () => {
    try {
        return (document.cookie || '')
            .split(/;[\s]*/)
            .reduce((accum, cookie) => {
            const indexOfFirstEq = cookie.indexOf('=');
            const cName = cookie.slice(0, indexOfFirstEq);
            const cValue = cookie.slice(indexOfFirstEq + 1);
            accum[decodeURIComponent(cName)] = decodeURIComponent(cValue);
            return accum;
        }, {});
    }
    catch (e) {
        console.error(`readCookie :: Could not read cookies.`, e);
        return {};
    }
};
export const readCookie = (name) => {
    return readCookies()[name];
};
//# sourceMappingURL=readCookie.js.map
// @zapier/cookies@1.1.3 (6a0d73ece)
